export const addUser = (user) => ({
    type: "OBSERVER_USER_ADDED",
    payload: user,
});
export const removeUser = (value) => ({
    type: "OBSERVER_USER_REMOVED",
    payload: { value: value },
});

